var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rs-side-panel',{ref:"sidePanel"},[_c('template',{slot:"body"},[_c('ProductForm',{attrs:{"side-view":"","hide-save":true,"hide-back-button":true,"id":_vm.id},on:{"saved":_vm.handleProductSaved,"cancelled":_vm.hide}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }